import React from "react";
import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "@/components/Reveal";

const EASE = [0.16, 1, 0.3, 1];

// Reusable header band for tab pages (compact, sits under fixed nav)
const PageHeader = ({ label, title, intro, tone = "dark" }) => {
  const dark = tone === "dark";
  return (
    <section
      className={`relative overflow-hidden ${dark ? "bg-forest-deep text-cream" : "bg-cream-2 text-forest"} pt-36 pb-16 sm:pt-40 sm:pb-20`}
    >
      {dark && (
        <div className="pointer-events-none absolute -top-24 -right-24 w-96 h-96 rounded-full bg-forest-surface/40 blur-3xl" aria-hidden />
      )}
      <div className="relative max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14">
        <SectionLabel dark={dark}>{label}</SectionLabel>
        <Reveal delay={0.1}>
          <h1 className="font-display font-light tracking-tight leading-[1.0] text-4xl sm:text-5xl lg:text-6xl mt-6 max-w-4xl">
            {title}
          </h1>
        </Reveal>
        {intro && (
          <Reveal delay={0.18}>
            <motion.p
              className={`mt-6 max-w-2xl text-base sm:text-lg font-light leading-relaxed ${dark ? "text-cream/75" : "text-forest/70"}`}
              transition={{ duration: 0.6, ease: EASE }}
            >
              {intro}
            </motion.p>
          </Reveal>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
